import { Radio, Row, Space, Table } from 'antd';
import styled from '@emotion/styled';
import { useState } from 'react';
import Chart, { Summary, Options } from './Chart';

export interface Config {
  radioGroup: {
    chart: string;
    table: string;
  };
  action: React.ReactNode;
  summary: Summary;
  tableColumns: any[];
  data: any[];
  chartOptions?: Options;
}

const Content = styled.div`
  padding: 0 24px;
  .ant-row {
    padding: 12px 0;
  }
`;

const Relative = styled.div`
  position: relative;
  width: 100%;
`;
export const RobotContributionTabContent = (props: Config) => {
  const { tableColumns, radioGroup, action, data, summary, chartOptions } = props;
  const [active, setActive] = useState<'chart' | 'table'>('chart');
  return (
    <Content>
      <Row justify="space-between">
        <Radio.Group value={active} onChange={(e) => setActive(e.target.value)}>
          <Radio.Button value="chart">{radioGroup.chart}</Radio.Button>
          <Radio.Button value="table">{radioGroup.table}</Radio.Button>
        </Radio.Group>
        <Space>{action}</Space>
      </Row>
      <Relative>
        {active === 'chart' ? (
          <Chart options={chartOptions} summary={summary} data={data} />
        ) : (
          <Table columns={tableColumns} dataSource={[...(data ?? [])]?.reverse()} />
        )}
      </Relative>
    </Content>
  );
};
export default RobotContributionTabContent;
